export default __webpack_public_path__ + "static/media/logo-apple.2c9fa987.svg";